import React from "react";
import { Button, Col, Row, Space } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setEsidExpTabPaneActive } from "../actions/esidExportAction";
import { esidExpTabsEnum } from "../constant/enumerations";
import { finalizedCodSts } from "../pages/admin/EsidExport/EsidExp";
import { DeclareCustomsContainer } from "./DeclareCustoms/DeclareCustomsContainer";

const TabDeclareCustoms = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const esidSelected = useSelector((state) => state.esidExport.esidExpSelected);
  const isEsidExpFinalized = esidSelected ? finalizedCodSts.includes(esidSelected.codSts) : false;

  const handleBackToESID = () => {
    window.scrollTo(0, 350);
    dispatch(setEsidExpTabPaneActive(esidExpTabsEnum.ExpRegis));
  };

  return (
    <>
      <p className="exp-sub-title" style={{ marginTop: "10px" }}>
        {t("formInfo.declCustomsLabel")}
      </p>
      <Row justify="center">
        <Col span={24} md={24} lg={22} xl={22} className="awb-tab-content">
          <p className="registry-notice">{t("header.registryInvNotice")}</p>
        </Col>
      </Row>
      <DeclareCustomsContainer isEsidExpFinalized={isEsidExpFinalized} />
      <Space
        style={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "center",
        }}
        className="awb-tab-content"
      >
        <Button onClick={handleBackToESID} style={{ width: "fit-content" }}>
          {t("formInfo.backToESID")}
        </Button>
      </Space>
    </>
  );
};

export default TabDeclareCustoms;
